import React from 'react'

// rSuite
import { Button } from 'rsuite'
import Icon from './Icon'

// redux
import { useDispatch } from 'react-redux'
import { setOption } from '../redux/options/actions' 
import { resetData } from '../redux/data/actions';


const ResetFiltersButton = ( { context = 'filters' } ) => {

  const dispatch = useDispatch()
  const onClick = () => 
  {
    // reset all filters
    dispatch( setOption( 'car', '', context ) ) 
    dispatch( setOption( 'group', '', context ) ) 
    dispatch( setOption( 'penalty', '', context ) ) 
    // reset data
    dispatch( resetData() ) 
  }

  return (
    <Button
      onClick={ onClick } 
      className="reset"
    ><Icon icon="refresh"/> <span className="label">Reset</span></Button>
  )
}

export default ResetFiltersButton